// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Qzh9","label":"Section_label__3m1ZY","contentWrap":"Section_contentWrap__2KzYz","footer":"Section_footer__2kDL3","footerInner":"Section_footerInner__2SIvC"};